export default "__VITE_ASSET__5cfc8500__"